import { useState } from 'react'

import {
  ActionLink,
  ActionRow,
} from '@/apps/latest/components/molecules/ActionLink'
import { useReleaseChannel } from '@/features/auth'
import { KasanHistoryModal } from '@/apps/latest/components/organisms/KasanHistoryModal'
import { DispenseAuditDialog } from '@/apps/latest/features/dispense-audit'

interface Props {
  yakurekiId: string
  patientName: string
}

// 患者単位の補助アクション (加算履歴 / 調剤鑑査).
// あまり触らない機能のため、 ⋯ dropdown ではなくページ下部の低 emphasis なテキスト行として置く。
// 遠隔服薬指導の操作はこの下の RemoteGuidanceRow (録音の前後どちらでも出す)。
export const PatientActionMenu = ({ yakurekiId, patientName }: Props) => {
  const [kasanHistoryOpen, setKasanHistoryOpen] = useState(false)
  const [auditDialogOpen, setAuditDialogOpen] = useState(false)
  const { isBeta } = useReleaseChannel()

  return (
    <>
      <ActionRow>
        <ActionLink
          label="加算履歴"
          onClick={() => setKasanHistoryOpen(true)}
        />
        {isBeta && (
          <ActionLink
            label="調剤鑑査"
            beta
            onClick={() => setAuditDialogOpen(true)}
          />
        )}
      </ActionRow>

      {/* 加算履歴モーダル */}
      <KasanHistoryModal
        open={kasanHistoryOpen}
        onClose={() => setKasanHistoryOpen(false)}
        yakurekiId={yakurekiId}
        patientName={patientName}
      />

      {/* 調剤鑑査ダイアログ */}
      <DispenseAuditDialog
        open={auditDialogOpen}
        onClose={() => setAuditDialogOpen(false)}
        yakurekiId={yakurekiId}
      />
    </>
  )
}
